import React from "react";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

interface DashboardCardProps {
  title: string;
  icon: React.ReactNode;
  count: number;
  color: string;
  path?: string;
  isEnabled?: boolean;
  comingSoon?: boolean;
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  icon,
  count,
  color,
  path,
  isEnabled = false,
  comingSoon = false,
}) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    // Coming soon olsa bile path varsa navigate et
    if (path && (isEnabled || comingSoon)) {
      navigate(path);
    }
  };

  return (
    <div className="position-relative">
      <Card
        onClick={handleCardClick}
        className={`dashboard-card ${(isEnabled || comingSoon) && path ? "clickable" : "disabled"}`}
        style={{
          background: comingSoon
            ? "rgba(255, 255, 255, 0.02)"
            : "rgba(255, 255, 255, 0.05)",
          backdropFilter: "blur(8px)",
          border: `1px solid ${color}${comingSoon ? "15" : "33"}`,
          borderRadius: "1rem",
          padding: "1.5rem",
          cursor: (isEnabled || comingSoon) && path ? "pointer" : "default",
          transition: "all 0.3s ease-in-out",
          boxShadow: comingSoon
            ? "0 4px 12px rgba(0,0,0,0.04)"
            : "0 8px 20px rgba(0,0,0,0.08)",
          opacity: comingSoon ? 0.7 : 1,
          filter: comingSoon ? "grayscale(20%)" : "none",
        }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <div
            className="icon-container"
            style={{
              backgroundColor: `${color}${comingSoon ? "08" : "15"}`,
              borderRadius: "50%",
              padding: "12px",
              color: comingSoon ? `${color}80` : color,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "52px",
              height: "52px",
              transition: "all 0.3s ease",
            }}
          >
            {icon}
          </div>
          <div className="text-end">
            <div
              style={{
                fontSize: "1.8rem",
                fontWeight: 600,
                color: comingSoon ? "#6c757d" : "inherit",
              }}
            >
              {count}
            </div>
            <div
              className="text-muted small text-uppercase"
              style={{
                opacity: comingSoon ? 0.5 : 0.8,
              }}
            >
              {title}
            </div>
          </div>
        </div>
        <div
          className="mt-3 text-muted"
          style={{
            fontSize: "0.75rem",
            opacity: comingSoon ? 0.8 : 0.6,
            fontWeight: comingSoon ? 500 : 400,
          }}
        >
          {comingSoon
            ? "Click to preview"
            : isEnabled
              ? "Click to manage"
              : "Coming soon"}
        </div>
      </Card>

      {/* Coming Soon Badge */}
      {comingSoon && (
        <div
          className="position-absolute"
          style={{
            top: "-8px",
            right: "-8px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            fontSize: "0.65rem",
            fontWeight: 600,
            padding: "4px 8px",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
            zIndex: 10,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
        >
          Coming Soon
        </div>
      )}

      {/* Coming Soon Overlay - Artık tıklanabilir */}
      {comingSoon && (
        <div
          className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            background: "rgba(255, 255, 255, 0.01)",
            backdropFilter: "blur(0.5px)",
            borderRadius: "1rem",
            zIndex: 5,
            pointerEvents: "none", // Overlay'in tıklamayı engellemesini önle
          }}
        ></div>
      )}
    </div>
  );
};

export default DashboardCard;
